import { PAGE_POSITIONS } from 'types';
import type { CapiProductPage } from 'types/capi/pdp';

import usePageData from '~/hooks/usePageData';

const RelatedCategories = () => {
  const product = usePageData<CapiProductPage>();

  return (
    <div className="flex flex-col gap-10">
      <h2 className="text-lg font-bold">Discover related categories</h2>
      <div className="flex flex-col gap-4 lg:flex-row">
        {product.related_categories.map((category) => (
          <a
            href={category.path}
            className="flex w-full items-center justify-center rounded-lg border border-black px-4 py-2.5 text-base font-semibold hover:text-gray-600"
            key={category.text}
            data-track_me="true"
            data-page_position={PAGE_POSITIONS.body}
          >
            {category.text}
          </a>
        ))}
      </div>
    </div>
  );
};

export default RelatedCategories;
